export default __webpack_public_path__ + "static/media/icon-park-outline_id-card-v.9296a7a0.svg";